var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.906 5.012C17.648 3.113 14.16 3.398 12 5.598c-2.16-2.2-5.648-2.489-7.906-.586-2.938 2.472-2.508 6.504-.414 8.64l6.851 6.98a2.05 2.05 0 0 0 2.938.005l6.851-6.98c2.09-2.137 2.528-6.169-.414-8.645",
    clipRule: "evenodd"
  })));
};
export default SvgHeartFilled;